export default __webpack_public_path__ + "static/media/ic_world.f5c6ca78.svg";